// import logo from './logo.svg';
import "./landing.css";

function Landing() {
	return (
		<>
			<div class="top">
				<h1 className="tiktok-sans">Eco Watch LLC.</h1>
			</div>
			<div class="content">
				<h2 className="noto-serif">
					We are a UAE based science-drive, tech-enabled environmental company.
				</h2>
				<h3 className="noto-serif">
					We provide advanced intelligence that combines field asset surveys and
					satellite imagery with AI to deliver high-precision, real-time information.
				</h3>
			</div>
			<div class="footer">
				<div class="foot-container">
					<div class="foot-items">
						<h4 className="tiktok-sans">
							Eco Watch LLC. - Al Qunout 3 St, MUSAFFAH, 17
							<br />
							Abu Dhabi 20330
							<br />
							UAE
						</h4>
					</div>
					<div class="foot-items">
						<h4 className="tiktok-sans">Call Us: +971 50 613 2949</h4>
					</div>
				</div>
			</div>
		</>
	);
}

export default Landing;
